import React, { Component } from 'react';
import axios from 'axios';
import { baseURL } from '../Helpers/Constants';
import DirectGoogleLogin from './DirectGoogleLogin'; // Import the new component
import FirebaseGoogleLogin from './FirebaseGoogleLogin'; // Import the new component

class LoginScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loginMethod: 'direct', // 'direct' or 'firebase'
      error: '',
    };
  }

  // A single, unified handler for successful logins from any method
  handleLoginSuccess = (authData, method) => {
    // SECURITY NOTE: For production, you should ALWAYS send the token to the backend
    // for verification, not just the email. This example matches your current backend.
    
    let requestBody = {};

    if (method === 'firebase') {
      // For a secure backend, you'd send the token
      requestBody = { email: authData };
    } else {
      // For a secure backend, you'd send authData.tokenId
      // For your current backend, we send the email
      requestBody = { email: authData.profileObj.email };
    }

    axios
      .post(baseURL() + '/api/v1/users/authenticate', requestBody, {
        headers: { 'app-auth-token': 'tI]iLCJ7J9%3Y%";hTL9' },
      })
      .then((res) => {
        if (res.data.success) {
            localStorage.setItem('userData', JSON.stringify(res.data.data));
            localStorage.setItem('userId', res.data.data._id);
            localStorage.setItem('jwtToken', res.data.data.jwt_token);
            localStorage.setItem('nodeJwtToken', res.data.data.jwt_token);

            localStorage.setItem('isLoggedIn', true);
            localStorage.setItem('username', res.data.data.name);
            localStorage.setItem('email', res.data.data.user);
            localStorage.setItem(
                'userSelectedColumn',
                JSON.stringify(res.data.data.selectedFields)
            );

            localStorage.setItem(
                'savedFilters',
                JSON.stringify(res.data.data.filters)
            );

            localStorage.setItem(
                'userPdfShareNumber',
                JSON.stringify(res.data.data.numberList)
            );
            localStorage.setItem(
                'userPdfShareEmail',
                JSON.stringify(res.data.data.emailList)
            );
            localStorage.setItem('isDeveloper', res.data.data.isDeveloper);
            localStorage.setItem('isAdmin', res.data.data.role);
            localStorage.setItem('permissions', res.data.data.permissions);

            window.location.reload();
            // this.setState({ redirectToReferrer: true });
        } else {
            this.setState({ error: res.data.message });
        }
      })
      .catch((error) => {
        console.log('Error:', error);
        this.setState({ error: error.message || 'An unknown error occurred.' });
      });
  };

  // A single handler for failures
  handleLoginFailure = (error) => {
    console.log('Login failed:', error.error);
    const errorMessage = error.details || error.error || 'Login failed due to a network or configuration issue.';
    this.setState({ error: String(errorMessage) });

  };
  
  // Toggles which login component is displayed
  toggleLoginMethod = () => {
    this.setState(prevState => ({
      loginMethod: prevState.loginMethod === 'direct' ? 'firebase' : 'direct',
      error: '', // Clear previous errors on switch
    }));
  };

  render() {
    return (
      <div className='container h-100 d-flex justify-content-center relative'>
        <div
          className='jumbotron'
          style={{ marginTop: 170, backgroundColor: 'transparent' }}
        >
          <div className='row' style={{ height: 45 }}>
            <p style={{ fontSize: 34, color: '#0A84FE', fontFamily: 'SF Pro Display Light' }}>
              Welcome to
            </p>
          </div>
          <div className='row' style={{ height: 158 }}>
            <p style={{ fontSize: 48, color: '#FFFFFF', lineHeight: 1.1, fontFamily: 'SF Pro Display Semibold' }}>
              Lead <br /> Management <br /> System
            </p>
          </div>
          <div className='row' style={{ marginTop: 60, marginBottom: 40, display: 'flex', justifyContent: 'center' }}>
            {this.state.loginMethod === 'direct' ? (
              <DirectGoogleLogin
                onSuccess={(response) => this.handleLoginSuccess(response, 'direct')}
                onFailure={this.handleLoginFailure}
              />
            ) : (
              <FirebaseGoogleLogin
                onSuccess={(token) => this.handleLoginSuccess(token, 'firebase')}
                onFailure={this.handleLoginFailure}
              />
            )}
          </div>

          {this.state.error&&<div className='row' style={{ marginTop: 5, textAlign: 'center' }}>
            <p style={{ color: 'red', fontSize: 15, fontFamily: 'SF Pro Text Medium' }}>
              {this.state.error}
            </p>
          </div>
  }
          
          {/* Toggle Button */}
          <button 
            onClick={this.toggleLoginMethod} 
            style={{ 
              position: 'absolute', 
              bottom: 20, 
              right: 20, 
              background: 'rgba(255,255,255,0.1)', 
              border: '1px solid rgba(255,255,255,0.2)',
              color: 'white',
              padding: '5px 10px',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '12px'
            }}
          >
            Use Google {this.state.loginMethod === 'direct' ? 'Firebase' : 'Direct'} Method to Login
          </button>
        </div>
      </div>
    );
  }
}

export default LoginScreen;